<script>
    import { onMount } from "svelte";
    import guff from "dataset:../_data/guff.aml";

    export let assets;
    const steps = guff["analysisMapbox"];

    import mapboxgl from "mapbox-gl";

    import Scroller from "@sveltejs/svelte-scroller";
    let index, offset, progress;
    // let sfr_switch;
    let isMobile, isSafari;
    let mobile_adjust = 1.2;

    let minZoomVal = 8,
        maxZoomVal = 22,
        startingZoom, // = isMobile ? 10 : 10.5,
        startingRotation = 0,
        startingPitch,
        startingCoordinates = [-115.098, 36.136];

    mapboxgl.accessToken =
        "pk.eyJ1IjoicHJvcHVibGljYSIsImEiOiJjaWt6dzNnNjQxbHBudTlrc3Nqc3NidG5qIn0.ChQFj8IDuUNxSg_I6_3Pnw";

    let map_graphic;
    let map_initiated = false;
    let synchronizedScrolls;
    // const synchronizedScrolls2 = [

    //     ]

    function preLoading(index) {
        // console.log('preloading', index)
        let step = synchronizedScrolls[index];
        // console.log(step)

        step.pts.forEach(async (pt) => {
            // console.log('loading step', pt)
            // await map.once('idle');
            map_graphic
                .jumpTo({
                    center: pt.start.center,
                    zoom: pt.start.zoom,
                    pitch: pt.start.pitch,
                    bearing: pt.start.bearing,
                    preloadOnly: true,
                })
                .easeTo({
                    center: pt.end.center,
                    zoom: pt.end.zoom,
                    pitch: pt.end.pitch,
                    bearing: pt.end.bearing,
                    preloadOnly: true,
                });
        });
    }
    function bearingTween(startB, endB, prog) {
        //to control for negative to positive bearings separated by several nominal degrees
        //this doesn't work yet.
        //convert into rads
        return startB + Math.abs(((startB + 360) % 360) - endB) * prog;
    }
    function posBearing(bearing) {
        return bearing;
        // (bearing + 360)%360
    }
    function syncScroll(index, progress) {
        // console.log(index,progress)
        const syncDataTop = synchronizedScrolls[index];
        //if only one step, this returns null... help!
        // console.log(syncDataTop);
        // console.log("SCROLL", {index, progress, zoom: map_graphic.getZoom(), center:[map_graphic.getCenter().lng, map_graphic.getCenter().lat]});

        const syncData =
            syncDataTop.pts.length === 1
                ? syncDataTop.pts[0]
                : syncDataTop.pts
                      .filter((d) => d.start.progress < progress)
                      .slice(-1)[0];
        // console.log(syncData)

        if (syncData) {
            // (syncDataTop.pts.filter(d=>d.end.progress>progress ).slice(-1) ||syncDataTop.pts.slice(-1))

            const { start, end } = syncData;

            const innerProg =
                (progress - start.progress) / (end.progress - start.progress);

            // console.log(innerProg)
            let scrollPoint, zoomLevel, bearingPt, pitchPt;

            if (progress > start.progress && progress < end.progress) {
                scrollPoint = {
                    lng:
                        start.center[0] +
                        (end.center[0] - start.center[0]) * innerProg,
                    lat:
                        start.center[1] +
                        (end.center[1] - start.center[1]) * innerProg,
                };
                zoomLevel = start.zoom + (end.zoom - start.zoom) * innerProg;

                // if (start.bearing < 0 && end.bearing>0) {
                // bearingPt= bearingTween(start.bearing,end.bearing,innerProg)
                // // posBearing(start.bearing) + (posBearing(end.bearing) - posBearing(start.bearing)) * innerProg;
                // }
                // else {
                let sb = start.bearing; // <0 ? start.bearing+360 : start.bearing;
                let eb = end.bearing; // <0 ? end.bearing+360 : end.bearing;
                bearingPt = sb + (eb - sb) * innerProg;
                // }

                // bearingTween(start.bearing,end.bearing,innerProg);

                pitchPt = start.pitch + (end.pitch - start.pitch) * innerProg;
            } else {
                if (progress >= end.progress) {
                    //if we're past the end of tween, ensure at end of xsition
                    scrollPoint = {
                        lng: end.center[0],
                        lat: end.center[1],
                    };
                    zoomLevel = end.zoom;
                    bearingPt = end.bearing;
                    pitchPt = end.pitch;
                } else {
                    //else ensure at beginning of sequence
                    scrollPoint = {
                        lng: start.center[0],
                        lat: start.center[1],
                    };
                    zoomLevel = start.zoom;
                    bearingPt = start.bearing;
                    pitchPt = start.pitch;
                }
            }

            map_graphic.jumpTo({
                // duration:0,
                center: scrollPoint,
                zoom: zoomLevel,
                bearing: bearingPt,
                pitch: pitchPt,
            });
            // console.log('did the jump')
        }
    }

    let mblayers = [
        {
            key: "nft-pt",
            layers: [
                "nft-30m-g-cmys5p copy 1",
                "nft-30m-g-cmys5p copy",
                "nft-30m-g-cmys5p",
                'nft-patch',
                'nft-patch copy',
                'nft-patch copy 1'
            ],
        },
        { key: "nft-vector", layers: ["nft-only"] },
        { key: "turf-vector", layers: ["functional-only"] },
        { key: "nft-glow", layers: ["nft-glow"] },
        { key: "sfr-glow", layers: ["sfr-glow"] },
        {
            key: "turf-pt",
            layers: [
                ,
                "all-turf-30mg-d6kbzi copy 1",
                "all-turf-30mg-d6kbzi copy",
                "all-turf-30mg-d6kbzi",
            ],
        },
        { key: "all-golf", layers: ["all-golf"] },
        {
            key: "golf-glow",
            layers: [
                "golf-glow", // golf polygons on line/blur
                "golf-pt-1",
                "golf-pt-2",
                "golf-pt-3", // same style as original 30m all-turf
            ],
        },
        { key: "just-sfr", layers: ["sfr"] },
    ];
    let layer_cache = {};
    function cacheData() {
        mblayers.forEach(function (group) {
            // console.log(group);
            group.layers.forEach(function (d) {
                // console.log(d);
                let layz = map_graphic.getLayer(d);
                // console.log(layz);
                if (layz.paint._values[`${layz.type}-opacity`]) {
                    layer_cache[d] =
                        layz.paint._values[`${layz.type}-opacity`].value.value;
                } else {
                    layer_cache[d] = 1;
                }
            });
        });
        // console.log(layer_cache)
    }
    function dimLayers(to_dim, dim_vals) {
        // let to_dim = dim_keys.map(o => o['key']);
        // console.log(to_dim)
        mblayers.forEach(function (group) {
            if (to_dim.includes(group.key)) {
                let key = group.key;

                group.layers.forEach(function (d) {
                    let layz = map_graphic.getLayer(d);
                    // console.log(d, layz);
                    map_graphic.setPaintProperty(
                        d,
                        `${layz.type}-opacity`,
                        dim_vals[to_dim.indexOf(key)]
                    );
                });
            } else {
                group.layers.forEach(function (d) {
                    let layz = map_graphic.getLayer(d);

                    map_graphic.setPaintProperty(
                        d,
                        `${layz.type}-opacity`,
                        layer_cache[d]
                    );
                });
            } //todo -- apply tweening
        });
    }
    function switchLayers(active) {
        mblayers.forEach(function (group) {
            // console.log
            if (active.includes(group.key)) {
                group.layers.forEach(function (d) {
                    map_graphic.setLayoutProperty(d, "visibility", "visible");
                });
            } else {
                group.layers.forEach(function (d) {
                    map_graphic.setLayoutProperty(d, "visibility", "none");
                });
            } //todo -- apply tweening
        });
    }

    let active_color = "#fff000";
    let sub_color = "#189a09";

    onMount(() => {
        isMobile = window.innerWidth < 740; //mobile check?
        // is_safari = (/^((?!chrome|android).)*safari/i).test(navigator.userAgent)
        startingZoom = isMobile ? 8.9 : 10.5;
        startingRotation = isMobile ? -20 : 0;
        startingPitch = isMobile ? 35 : 0;
        if (isMobile) {
            startingCoordinates = [-115.063261, 36.077642];
            synchronizedScrolls = [
                {
                    //0 all turf
                    pts: [
                        {
                            start: {
                                progress: 0.02,
                                center: startingCoordinates,
                                zoom: startingZoom,
                                pitch: startingPitch,
                                bearing: startingRotation,
                            },

                            end: {
                                progress: 0.09,
                                center: [-115.172928, 36.157032],
                                zoom: 9.5,
                                pitch: 20,
                                bearing: 0,
                            },
                        },
                    ],
                },
                {
                    //1 to nft
                    pts: [
                        {
                            start: {
                                progress: 0.1,
                                center: [-115.172928, 36.157032],
                                zoom: 9.5,
                                pitch: 20,
                                bearing: 0,
                            },

                            end: {
                                progress: 0.29,
                                center: [-115.323627, 36.169657],
                                zoom: 14.5,
                                pitch: 37.8,
                                bearing: 16.86,
                            },
                        },
                    ],
                },
                {
                    //2 to roadway
                    pts: [
                        {
                            start: {
                                progress: 0.3,
                                center: [-115.323627, 36.169657],
                                zoom: 14.5,
                                pitch: 37.8,
                                bearing: 16.86,
                            },

                            end: {
                                progress: 0.5,
                                center: [-115.289789, 36.198643],
                                zoom: 13.5,
                                pitch: 30,
                                bearing: 50,
                            },
                        },
                    ],
                },
                {
                    //3 to ds
                    pts: [
                        {
                            start: {
                                progress: 0.5,
                                center: [-115.289789, 36.198643],
                                zoom: 13.5,
                                pitch: 30,
                                bearing: 50,
                            },

                            end: {
                                progress: 0.63,
                                center: [-115.272281, 36.208631],
                                zoom: 14.85,
                                pitch: 30,
                                bearing: 60,
                            },
                        },
                    ],
                },
                {
                    //4 ds to sfr
                    pts: [
                        {
                            start: {
                                progress: 0.7,
                                center: [-115.272281, 36.208631],
                                zoom: 14.85,
                                pitch: 30,
                                bearing: 60,
                            },

                            end: {
                                progress: 0.89,
                                center: [-115.295224, 36.196921],
                                zoom: 15,
                                pitch: 30,
                                bearing: 30,
                            },
                        },
                    ],
                },
                {
                    //5
                    pts: [
                        {
                            start: {
                                progress: 0.9,
                                center: [-115.295224, 36.196921],
                                zoom: 15,
                                pitch: 30,
                                bearing: 30,
                            },
                            end: {
                                progress: 0.95,
                                center: [-115.295224, 36.196921],
                                zoom: 13,
                                pitch: 30,
                                bearing: 0,
                            },
                        },
                        {
                            start: {
                                progress: 0.95,
                                center: [-115.295224, 36.196921],
                                zoom: 13,
                                pitch: 30,
                                bearing: 0,
                            },
                            end: {
                                progress: 0.99,
                                center: [-115.295224, 36.196921],
                                zoom: 9.5,
                                pitch: 0,
                                bearing: 0,
                            },
                        },
                        {
                            start: {
                                progress: 0.99,
                                center: [-115.295224, 36.196921],
                                zoom: 9.5,
                                pitch: 0,
                                bearing: 0,
                            },
                            end: {
                                progress: 1.0,
                                center: [-115.2, 36.25],
                                zoom: startingZoom,
                                pitch: 35,
                                bearing: -30,
                            },
                        },
                    ],
                },
            ];
        } else {
            synchronizedScrolls = [
                {
                    //0 all turf
                    pts: [
                        {
                            start: {
                                progress: 0.05,
                                center: startingCoordinates,
                                zoom: startingZoom,
                                pitch: startingPitch,
                                bearing: 0,
                            },
                            end: {
                                progress: 0.14,
                                center: [-115.216036, 36.131322],
                                zoom: 11,
                                pitch: 0,
                                bearing: 0,
                            },
                        },
                    ],
                },
                {
                    //1 to nft
                    pts: [
                        {
                            start: {
                                progress: 0.15,
                                center: [-115.216036, 36.131322],
                                zoom: 11,
                                pitch: 0,
                                bearing: 0,
                            },
                            end: {
                                progress: 0.25,
                                center: [-115.313077, 36.170707],
                                zoom: 13.48,
                                pitch: 19.3,
                                bearing: 18.46,
                            },
                        },
                        {
                            start: {
                                progress: 0.25,
                                center: [-115.313077, 36.170707],
                                zoom: 13.48,
                                pitch: 19.3,
                                bearing: 18.46,
                            },
                            end: {
                                progress: 0.3,
                                center: [-115.323627, 36.169657],
                                zoom: 14.85,
                                pitch: 37.8,
                                bearing: 16.86,
                            },
                        },
                    ],
                },
                {
                    //2 to roadway
                    pts: [
                        {
                            start: {
                                progress: 0.31,
                                center: [-115.323627, 36.169657],
                                zoom: 14.85,
                                pitch: 37.8,
                                bearing: 16.86,
                            },
                            end: {
                                progress: 0.36,
                                center: [-115.324289, 36.171005],
                                zoom: 16.25,
                                pitch: 40.3,
                                bearing: 16.86,
                            },
                        },
                        {
                            start: {
                                progress: 0.36,
                                center: [-115.324289, 36.171005],
                                zoom: 16.25,
                                pitch: 40.3,
                                bearing: 16.86,
                            },
                            end: {
                                progress: 0.46,
                                center: [-115.318805, 36.17755],
                                zoom: 16.25,
                                pitch: 0,
                                bearing: 57.5,
                            },
                        },
                        {
                            start: {
                                progress: 0.46,
                                center: [-115.318805, 36.17755],
                                zoom: 16.25,
                                pitch: 0,
                                bearing: 57.5,
                            },
                            end: {
                                progress: 0.5,
                                center: [-115.289789, 36.198643],
                                zoom: 14.7,
                                pitch: 30,
                                bearing: 57.5,
                            },
                        },
                    ],
                },
                {
                    //3 to ds
                    pts: [
                        {
                            start: {
                                progress: 0.5,
                                center: [-115.289789, 36.198643],
                                zoom: 14.7,
                                pitch: 30,
                                bearing: 57.5,
                            },
                            end: {
                                progress: 0.56,
                                center: [-115.270443, 36.210502],
                                zoom: 15.44,
                                pitch: 45,
                                bearing: 37,
                            },
                        },
                        {
                            start: {
                                progress: 0.56,
                                center: [-115.270443, 36.210502],
                                zoom: 15.44,
                                pitch: 45,
                                bearing: 37,
                            },
                            end: {
                                progress: 0.6,
                                center: [-115.270274, 36.208311],
                                zoom: 15.87,
                                pitch: 40,
                                bearing: 18.4,
                            },
                        },
                        {
                            start: {
                                progress: 0.6,
                                center: [-115.270274, 36.208311],
                                zoom: 15.87,
                                pitch: 40,
                                bearing: 18.4,
                            },
                            end: {
                                progress: 0.68,
                                center: [-115.270153, 36.20705],
                                zoom: 15.05,
                                pitch: 25,
                                bearing: 0,
                            },
                        },
                    ],
                },
                {
                    //4 ds to sfr
                    pts: [
                        {
                            start: {
                                progress: 0.7,
                                center: [-115.270153, 36.20705],
                                zoom: 15.05,
                                pitch: 25,
                                bearing: 0,
                            },
                            end: {
                                progress: 0.75,
                                center: [-115.270153, 36.20705],
                                zoom: 15.05,
                                pitch: 25,
                                bearing: -12,
                            },
                        },
                        {
                            start: {
                                progress: 0.75,
                                center: [-115.270153, 36.20705],
                                zoom: 15.05,
                                pitch: 25,
                                bearing: -12,
                            },
                            end: {
                                progress: 0.78,
                                center: [-115.280615, 36.199893],
                                zoom: 15.72,
                                pitch: 30,
                                bearing: -22,
                            },
                        },
                        {
                            start: {
                                progress: 0.78,
                                center: [-115.280615, 36.199893],
                                zoom: 15.72,
                                pitch: 30,
                                bearing: -22,
                            },
                            end: {
                                progress: 0.84,
                                center: [-115.295224, 36.196921],
                                zoom: 15.39,
                                pitch: 35,
                                bearing: -29,
                            },
                        },
                        {
                            start: {
                                progress: 0.84,
                                center: [-115.295224, 36.196921],
                                zoom: 15.39,
                                pitch: 35,
                                bearing: -29,
                            },
                            end: {
                                progress: 0.89,
                                center: [-115.295224, 36.196921],
                                zoom: 15.39,
                                pitch: 35,
                                bearing: -34,
                            },
                        },
                    ],
                },
                {
                    //5
                    pts: [
                        {
                            start: {
                                progress: 0.9,
                                center: [-115.295224, 36.196921],
                                zoom: 15.39,
                                pitch: 30,
                                bearing: -34,
                            },
                            end: {
                                progress: 0.92,
                                center: [-115.295982, 36.194121],
                                zoom: 14.97,
                                pitch: 28,
                                bearing: -22,
                            },
                        },
                        {
                            start: {
                                progress: 0.92,
                                center: [-115.295982, 36.194121],
                                zoom: 14.97,
                                pitch: 28,
                                bearing: -22,
                            },
                            end: {
                                progress: 0.95,
                                center: [-115.293497, 36.186561],
                                zoom: 14.54,
                                pitch: 24,
                                bearing: 0,
                            },
                        },
                        {
                            start: {
                                progress: 0.95,
                                center: [-115.293497, 36.186561],
                                zoom: 14.54,
                                pitch: 24,
                                bearing: 0,
                            },
                            end: {
                                progress: 0.97,
                                center: [-115.298321, 36.193845],
                                zoom: 13,
                                pitch: 8,
                                bearing: 0,
                            },
                        },
                        {
                            start: {
                                progress: 0.97,
                                center: [-115.298321, 36.193845],
                                zoom: 13,
                                pitch: 8,
                                bearing: 0,
                            },

                            end: {
                                progress: 0.99,
                                center: [-115.308507, 36.178719],
                                zoom: 11,
                                pitch: 8,
                                bearing: 0,
                            },
                        },
                        {
                            start: {
                                progress: 0.99,
                                center: [-115.308507, 36.178719],
                                zoom: 11,
                                pitch: 20,
                                bearing: 0,
                            },
                            end: {
                                progress: 1.0,
                                center: startingCoordinates,
                                zoom: startingZoom,
                                pitch: 0,
                                bearing: 0,
                            },
                        },
                    ],
                },
            ];
        }

        // let isMobile = mobile_check();
        // console.log("making map_graphic");
        map_graphic = new mapboxgl.Map({
            container: "graphic-mapbox",
            style: "mapbox://styles/propublica/cli4wt35k00xg01r88sk8a2ba",
            minZoom: minZoomVal,
            maxZoom: maxZoomVal,
            zoom: startingZoom,
            pitch:startingPitch,
            bearing: startingRotation,
            center: startingCoordinates,
            pitch: 0,
        });

        map_graphic.on("load", async () => {
            // console.log("map_graphic loaded", map_graphic);
            cacheData();

            map_initiated = true;

            switchLayers([
                "turf-pt",
                "nft-pt",
                "turf-vector",
                "nft-vector",
                "all-golf",
            ]);
            // await map_graphic.once('idle')
            // console.log('map_idled')
            // preLoading(1)
        });

        // console.log(map_graphic)
    });
    $: {
        // console.log(index);
        if (map_graphic && map_initiated === true) {
            syncScroll(index, progress);
        }
    }
    $: {
        if (map_graphic && map_initiated === true) {
            // console.log(index);
            if (index == 0) {
                //whole valley

                dimLayers(["nft-pt", "nft-vector"], [0, 0]);
                switchLayers([
                    "turf-pt",
                    "nft-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                    "golf-glow",
                ]);
            }
            if (index == 1) {
                // slight zoom, display nft

                switchLayers([
                    "turf-pt",
                    "nft-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                ]);
                dimLayers(
                    ["turf-pt", "turf-vector", "all-golf"],
                    [0, 0.35, 0.35]
                );
            }
            if (index == 2) {
                switchLayers([
                    "turf-pt",
                    "nft-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                    "nft-glow",
                ]);
                dimLayers(
                    ["turf-pt", "turf-vector", "all-golf", "just-sfr"],
                    [0, 0.2, 0.2, 0]
                );
            }
            if (index == 3) {
                switchLayers([
                    "turf-pt",
                    "nft-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                    "just-sfr",
                    "nft-glow",
                ]);
                dimLayers(
                    ["turf-pt", "turf-vector", "all-golf", "just-sfr"],
                    [0, 0.2, 0.2, 0]
                );
            }
            if (index == 4) {
                switchLayers([
                    "turf-pt",
                    "nft-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                    "just-sfr",
                    "sfr-glow",
                    "nft-glow",
                ]);
                dimLayers(
                    [
                        "nft-vector",
                        "turf-pt",
                        "turf-vector",
                        "all-golf",
                        "just-sfr",
                        "nft-glow",
                    ],
                    [0.1, 0, 0.2, 0.2, 1, 0]
                );
                // switchLayers(['just-sfr','nft-new','all-golf'])
            }
            if (index == 5) {
                switchLayers([
                    "turf-pt",
                    "turf-vector",
                    "nft-vector",
                    "all-golf",
                    "just-sfr",
                    "sfr-glow",
                    "golf-glow",
                ]);
                dimLayers(
                    [
                        "nft-vector",
                        "turf-pt",
                        "turf-vector",
                        "all-golf",
                        "just-sfr",
                        "sfr-glow",
                    ],
                    [0.1, 0, 0.2, 1, 0, 0]
                );

                // dimLayers([ 'nft-new','all-turf-new'],[0,.02])
                // switchLayers(['all-golf'])
            }
            // preLoading(index)
        } // end of is map none
    } // end of $:
</script>

<Scroller threshold={0.5} bind:index bind:offset bind:progress>
    <div class="background" slot="background">
        <div class="graphic-container">
            <div id="graphic-mapbox" />
            <img
                id="locator-map"
                src={assets[0]}
                class:hide-locator-map={index + offset + progress > 0.5}
                alt="Locator map of Columbia Basin area."
            />
        </div>
    </div>

    <div class="foreground" slot="foreground">
        {#each steps as text, i}
            <section>
                <div
                    class="graf center graf-{i}"
                    class:active={Math.round(index / 2) === i}
                >
                    <p>{@html text.value}</p>
                </div>
            </section>
        {/each}
    </div>
</Scroller>

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";

    p {
        line-height: var(--line-height0);
    }

    .background {
        height: 100vh;
        width: 100%;
    }

    section {
        height: 150vh;
        display: grid;
        place-content: center;

        @include breakpoint-min(xl) {
            place-content: center end;
            margin-right: 10%;
        }
    }

    .graf {
        line-height: var(--line-height-1);
        transition: var(--transition);
        line-height: var(--line-height-1);
        transition: var(--transition);
        max-width: 550px;
        padding: var(--spacing0);
        background: #fefefe;
        opacity: 1;
        border: var(--intro-stroke);
        margin: 0 var(--spacing0);
    }

    .graphic-container {
        width: auto;
        height: auto;
        object-fit: cover;
    }
    #graphic-mapbox {
        width: 100vw;
        height: 100vh;
    }
    .mapboxgl-control-container {
        display: none !important;
    }

    #locator-map {
        position: absolute;
        bottom: calc(20px + var(--spacing-1));
        left: var(--spacing0);
        height: auto;
        width: 150px;
        opacity: 1;
        transition: opacity 0.4s;

        @include breakpoint-max(sm) {
            top: calc(45px + var(--spacing-1));
            bottom: auto;
            left: auto;
            width: 100px;
            right: var(--spacing-1);

            &.hide-locator-map {
                opacity: 0;
            }
        }
    }
</style>
